import React, {Fragment, useEffect, useState} from 'react';
import {Box, Checkbox, FormControlLabel, Grid, Tab, Tabs, Tooltip, Typography, useTheme} from "@mui/material";
import {useTranslation} from "react-i18next";
import {v4} from "uuid";
import {useRecoilValue} from "recoil";
import {profileDetailStructure} from "../state/profileState";
import {InfoRounded} from "@mui/icons-material";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}

const ProfileAuth = ({selectedAuths, setSelectedAuths, setValue, getValues}: any) => {
    const {t} = useTranslation(['operator']);
    const theme = useTheme();
    const {authDtos} = useRecoilValue(profileDetailStructure);
    const [departments, setDepartments] = useState<any>({});
    const [tabSelected, setTabSelected] = React.useState(0);
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabSelected(newValue);
    };

    useEffect(() => {
        let tmpDepartments: any = {};
        authDtos.forEach((item: any) => {
            if (!tmpDepartments[item.department]) {
                tmpDepartments[item.department] = [];
            }
            tmpDepartments[item.department].push(item);
        });

        let groupedDepartments: any = {};
        Object.entries(tmpDepartments).map(([department, auths]: any, index) => {
            let tmpFeatures: any = {};
            auths.forEach((item: any) => {
                if (!tmpFeatures[item.feature]) {
                    tmpFeatures[item.feature] = [];
                }
                tmpFeatures[item.feature].push(item);
            });
            groupedDepartments[department] = tmpFeatures;
        });
        setDepartments(groupedDepartments);

    }, [authDtos]);

    function TabPanel(props: TabPanelProps) {
        const {children, value, index, ...other} = props;

        return (
            <Grid item xs={12}
                  role="tabpanel"
                  hidden={value !== index}
                  id={`simple-tabpanel-${index}`}
                  aria-labelledby={`simple-tab-${index}`}
                  {...other}
            >
                {value === index && (
                    <Box>
                        {children}
                    </Box>
                )}
            </Grid>
        );
    }

    const getAuth = () => {
        return Object.entries(departments).map(([department, features]: any, index) => (
            <Fragment key={v4()}>
                <TabPanel value={tabSelected} index={index}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12}>
                            <FormControlLabel
                                color={'accent'}
                                control={<Checkbox color={'accent'}
                                                   checked={!!selectedAuths.find((a: any) => a.name === "department_".concat(department))}/>}
                                label={<Typography variant={"h6"}>{t('label.selectAll')}</Typography>}
                                name={'selectAll'}
                                onChange={(event, checked) => {
                                    let tmpAuths = getValues("auths");
                                    Object.entries(features).map(([feature, auths]: any, index) => {
                                        auths.forEach((a: any) => {
                                            if (checked) {
                                                if (!tmpAuths.find((tmpA: any) => tmpA.name === "department_".concat(department))) {
                                                    tmpAuths.push({name: "department_".concat(department)});
                                                }
                                                if (!tmpAuths.find((tmpA: any) => tmpA.name === "feature_".concat(feature))) {
                                                    tmpAuths.push({name: "feature_".concat(feature)});
                                                }
                                                if (!tmpAuths.find((tmpA: any) => tmpA.name === a.name)) {
                                                    tmpAuths.push(a);
                                                }
                                            } else {
                                                tmpAuths = tmpAuths.filter((tmpA: any) => tmpA.name !== "department_".concat(department));
                                                tmpAuths = tmpAuths.filter((tmpA: any) => tmpA.name !== "feature_".concat(feature));
                                                tmpAuths = tmpAuths.filter((tmpA: any) => tmpA.name !== a.name);
                                            }
                                        });
                                        setValue("auths", tmpAuths);
                                        setSelectedAuths(tmpAuths);
                                    });
                                }}
                            />
                        </Grid>
                        {Object.entries(features).map(([feature, auths]: any, index) => (
                            <Fragment key={v4()}>
                                <Grid item xs={12}>
                                    <FormControlLabel
                                        control={<Checkbox color={'accent'}
                                                           checked={!!selectedAuths.find((a: any) => a.name === "feature_".concat(feature))}/>}
                                        label={<Typography variant={"h6"}>{t('label.selectAll') + ': ' + t('translation:features.'.concat(feature))}</Typography>}
                                        name={feature}
                                        onChange={(event, checked) => {
                                            let tmpAuths = getValues("auths");
                                            auths.forEach((a: any) => {
                                                if (checked) {
                                                    if (!tmpAuths.find((tmpA: any) => tmpA.name === "feature_".concat(feature))) {
                                                        tmpAuths.push({name: "feature_".concat(feature)});
                                                    }
                                                    if (!tmpAuths.find((tmpA: any) => tmpA.name === a.name)) {
                                                        tmpAuths.push(a);
                                                    }
                                                } else {
                                                    tmpAuths = tmpAuths.filter((tmpA: any) => tmpA.name !== "feature_".concat(feature));
                                                    tmpAuths = tmpAuths.filter((tmpA: any) => tmpA.name !== a.name);
                                                }
                                            });
                                            setValue("auths", tmpAuths);
                                            setSelectedAuths(tmpAuths);
                                        }}
                                    />
                                </Grid>
                                {auths.map((auth: any) => (
                                    <Fragment key={v4()}>
                                        <Grid item xs={4} sm={2}>
                                            <FormControlLabel
                                                control={<Checkbox color={'accent'}
                                                                   checked={!!selectedAuths.find((a: any) => a.name === auth.name)}/>}
                                                label={t('translation:auths.'.concat(auth.name).concat('.name'))}
                                                name={auth.name}
                                                onChange={() => {
                                                    let tmpAuths = getValues("auths");
                                                    tmpAuths.find((a: any) => a.name === auth.name)
                                                        ? tmpAuths = tmpAuths.filter((a: any) => a.name !== auth.name)
                                                        : tmpAuths.push(auth);
                                                    setValue("auths", tmpAuths);
                                                    setSelectedAuths(tmpAuths);
                                                }}
                                            />
                                        </Grid>
                                        <Grid item xs={1}>
                                            <Tooltip title={
                                                <Fragment>
                                                    <Typography color="inherit"
                                                                variant={'h6'}>{t('label.description')}: </Typography>
                                                    <Typography color="inherit"
                                                                variant={'body1'}>{t('translation:auths.'.concat(auth.name).concat('.description'))}</Typography>
                                                    <Typography color="inherit"
                                                                variant={'h6'}>{t('label.path')}: </Typography>
                                                    <Typography color="inherit"
                                                                variant={'body1'}>{t('translation:auths.'.concat(auth.name).concat('.path'))}</Typography>
                                                </Fragment>
                                            }>
                                                <InfoRounded color={'secondary'}/>
                                            </Tooltip>
                                        </Grid>
                                    </Fragment>
                                ))}
                            </Fragment>
                        ))}
                    </Grid>
                </TabPanel>
            </Fragment>
        ));
    };

    function a11yProps(index: number) {
        return {
            id: `profile-tab-${index}`,
            'aria-controls': `profile-tabpanel-${index}`,
        };
    }

    const getTabs = () => {
        return Object.entries(departments).map(([department]: any, index) => (
            <Tab key={v4()} label={t('translation:departments.'.concat(department))} {...a11yProps(index)}
                 sx={{borderBottom: `3px solid ${theme.palette.neutral.dark}`, minWidth: "fit-content", flex: 1}}/>
        ));
    };

    return (
        <Fragment>
            <Grid item xs={12}>
                <Tabs value={tabSelected} onChange={handleChange} aria-label="profile-tabs"
                      variant="scrollable"
                      scrollButtons={false}
                >
                    {getTabs()}
                </Tabs>
            </Grid>
            {getAuth()}
        </Fragment>
    );
};

export default ProfileAuth;